import { useState } from 'react';

const useLimitedLengthString = (maxLength: number, defaultValue: string): [string, (value: unknown) => void] => {
    const [value, setValue] = useState<string>(defaultValue);

    const updateValue = (nextValue: unknown) => {
        if (!nextValue) {
            setValue(defaultValue);
        } else {
            const nextValueString = nextValue.toString() ?? defaultValue;

            if (nextValueString.length <= maxLength) {
                setValue(nextValueString);
            }
        }
    };

    return [value, updateValue];
};

export default useLimitedLengthString;
